import Part from "../../part";

export default class Appetizers extends Part {

  constructor(section) {
    super(section);

  }

  get options() {
    return {

      'simple': {
        price: 5,
        description: `Simple stationed appetizers such as Laura’s Luscious Dips (hummus, tapenade, and marash feta spread with breads) and vegetable crudite.`,
      },
      'medium': {
        price: 10,
        description: `A wider variety of heartier stationed appetizers that could include Italian meatballs, chicken skewers with peanut sauce, and Sean’s Sensational Cheese Basket.`,
      },
      'deluxe': {
        price: 15,
        description: `Multiple higher end options that can be served tray passed and/or stationed. Choices include Bacon and Blue Cheese Dates, tamari- marinated flank steak skewers, and Bayou Bob’s Shrimp Cocktail.  This option can also be chosen if you are looking for a dinner of heavy appetizers (no entree).`,
      },
      'none': {
        price: 0,
      },
    };
  }

}



// WEBPACK FOOTER //
// ./scripts/catcalc/sections/food/appetizers.js